import React from "react";
import Frame from "../chrome/Frame";
import Meta from "../chrome/Meta";
import Caps from "../parts/Caps";
import Invite from "../parts/Invite";

const Capabilities = () => (
  <Frame>
    <Meta title="Capabilities" description="Nine senior-led marketing capabilities — strategy, paid, content, social, identity, growth, analytics, PR." />
    <section className="svc-hero">
      <div className="shell">
        <div className="crumb"><a href="/">Home</a><span className="sep">/</span>Capabilities</div>
        <span className="eyebrow">Capabilities</span>
        <h1>Nine disciplines under one accountable team.</h1>
        <p className="lede">
          Each capability can be engaged on its own. Most engagements combine three or more — sequenced against where
          the brand actually is today and where it needs to be in 12 months.
        </p>
      </div>
    </section>
    <section className="band">
      <div className="shell">
        <Caps />
      </div>
    </section>
    <Invite />
  </Frame>
);

export default Capabilities;
